import { useEffect, FunctionComponent, useState } from 'react'
import Script from 'next/script'

import config from '@config'
import { setLocalStorageItem } from '@utils/localStorage'

const {
  backend: { env },
  notifications: { onesignalSdkUrl, appId, playerIdStorageKey },
} = config

const OneSignal: FunctionComponent = () => {
  const [isOneSignalSDKLoaded, setIsOneSignalSDKLoaded] =
    useState<boolean>(false)

  useEffect(() => {
    if (isOneSignalSDKLoaded) {
      window.OneSignal.push(() => {
        window.OneSignal.on('subscriptionChange', (isSubscribed: boolean) => {
          if (isSubscribed) {
            window.OneSignal.getUserId().then((userId: string) => {
              setLocalStorageItem(playerIdStorageKey, userId)
            })
          } else {
            setLocalStorageItem(playerIdStorageKey, '')
          }
        })

        window.OneSignal.init({
          appId,
        })
      })
    }
  }, [isOneSignalSDKLoaded])

  if (!['stg', 'prod'].includes(env)) {
    return null
  }

  return (
    <Script
      src={onesignalSdkUrl}
      strategy="lazyOnload"
      onLoad={() => setIsOneSignalSDKLoaded(true)}
    />
  )
}

export default OneSignal
